import { Instagram, Facebook, MessageCircle } from "lucide-react";
import { SITE } from "../data/site";
import { ORDER_URL } from "../data/menu";

const NAV = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Menu", href: "#menu" },
  { label: "Gallery", href: "#gallery" },
  { label: "Contact", href: "#contact" },
];

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-brand-ink text-brand-cream pt-20 pb-8 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-12 pb-14 border-b border-brand-cream/10">
          <div className="md:col-span-5">
            <div className="flex items-center mb-5">
              <img 
                src="/logo.png" 
                alt="Red Chilly's Logo" 
                className="h-14 md:h-16 w-auto object-contain brightness-0 invert" 
              />
            </div>
            <p className="text-brand-cream/65 leading-relaxed max-w-md">
              Family-owned. Fiercely flavourful. Serving Pittsburgh the recipes that
              raised us — one plate of biryani at a time.
            </p>
            <div className="mt-6 flex gap-3">
              {[
                { Icon: Instagram, href: SITE.social.instagram, label: "Instagram" },
                { Icon: Facebook, href: SITE.social.facebook, label: "Facebook" },
                { Icon: MessageCircle, href: SITE.social.yelp, label: "Yelp" },
              ].map(({ Icon, href, label }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  data-testid={`social-${label.toLowerCase()}`}
                  className="w-11 h-11 rounded-full border border-brand-cream/15 hover:bg-brand-red hover:border-brand-red flex items-center justify-center transition-all hover:-translate-y-1"
                >
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading uppercase text-[11px] tracking-[0.3em] font-bold text-brand-mustard mb-5">
              Quick Links
            </h4>
            <ul className="space-y-3">
              {NAV.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="font-heading uppercase text-sm tracking-[0.1em] font-bold text-brand-cream/80 hover:text-brand-red transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-heading uppercase text-[11px] tracking-[0.3em] font-bold text-brand-mustard mb-5">
              Visit & Order
            </h4>
            <p className="text-brand-cream/70 mb-2">{SITE.address}</p>
            <a
              href={SITE.phoneHref}
              className="block font-display text-2xl text-brand-cream hover:text-brand-mustard transition-colors mb-5"
            >
              {SITE.phone}
            </a>
            <a
              href={ORDER_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-order-cta"
              className="inline-flex items-center px-6 py-3 rounded-full bg-brand-red text-brand-cream font-heading uppercase text-xs tracking-[0.2em] font-bold hover:bg-brand-deepred transition-all hover:-translate-y-0.5"
            >
              Order Online
            </a>
          </div>
        </div>

        {/* Giant brand text */}
        <div className="py-10 text-center">
          <div className="font-display uppercase text-[5rem] sm:text-[8rem] md:text-[12rem] lg:text-[15rem] leading-none text-transparent bg-clip-text bg-gradient-to-b from-brand-cream/15 to-brand-cream/0 select-none">
            Red Chilly's
          </div>
        </div>

        <div className="flex flex-col md:flex-row gap-4 items-center justify-between text-xs font-heading uppercase tracking-[0.18em] font-bold text-brand-cream/40">
          <span>
            © 2026 Red Chilly's · India's Street Kitchen. All rights reserved. 
            Powered by <a href="https://getaivry.com/" target="_blank" rel="noopener noreferrer" className="hover:text-brand-cream transition-colors underline underline-offset-4">Aivry</a>
          </span>
        </div>
      </div>
    </footer>
  );
};
